// Registry of support-only tools rendered inside the "Tools" menu on the
// masquerade header (see SupportHeader.jsx / SupportToolsMenu.jsx).
//
// To add a new tool:
//   1. Add one entry below — a unique `id`, a `label`, the `group` heading
//      the menu should file it under, and an `onSelect(ctx)` that flips the
//      relevant MainLayout state setter. Wire that setter through as an
//      `onOpen*` prop on <SupportHeader> in MainLayout.jsx, and expose it on
//      the `ctx` object SupportHeader builds for the menu.
//   2. Mount the tool's own modal in MainLayout.jsx, gated on its state
//      flag, exactly like the existing modals (AdvertiserChangeHistoryModal,
//      CpaForecastModal, ...).
// No changes to SupportHeader.jsx or SupportToolsMenu.jsx are needed — the
// menu renders whatever this list contains, grouped by `group`, and shows a
// filter search once the visible tool count passes the search threshold.
export const SUPPORT_TOOLS = [
  {
    id: "change-history",
    label: "Change history",
    group: "Account",
    isVisible: () => true,
    onSelect: (ctx) => ctx.setChangeHistory(true),
  },
  {
    id: "cpa-forecast",
    label: "CPA Forecast",
    group: "Insights",
    isVisible: () => true,
    onSelect: (ctx) => ctx.setCpaForecast(true),
  },
];
